<template>
    <div class="products-search-bar" v-if="cCats.length">
        <ui-search v-model="term" placeholder="Buscador" @search="handleSearch">
            <ui-select label="Categoría" class="fix-cats" hide-label value="" v-model="catId" :options="cCats"
                @changed="handleSearch" />
        </ui-search>
    </div>
</template>

<script>
import _ from 'lodash'
import UiSearch from '../shared/UiSearch.vue';
import { mapGetters } from 'vuex';

export default {
    name: 'ProductsSearchBar',
    props: {
        propsEmptyCatLabel: {
            type: String,
            default: '-- Cualquier categoría --'
        },
        specificCats: {
            type: Array,
            default: () => []
        },
        isProcessing: {
            type: Boolean,
            default: false
        }
    },
    components: {
        UiSearch
    },
    computed: {
        ...mapGetters(['catalogCats']),
        cCatsSpecified() {
            return [
                { value: null, label: (this.propsEmptyCatLabel).toUpperCase() },
                ...this.specificCats.map(cat => {
                    return {
                        value: cat.id,
                        label: cat.categoria_nombre.toUpperCase()
                    }
                })
            ]
        },
        cCatsGeneral() {
            return [
                { value: null, label: (this.propsEmptyCatLabel).toUpperCase() },
                ...this.catalogCats.map(cat => {
                    return {
                        value: cat.id,
                        label: cat.categoria_nombre.toUpperCase()
                    }
                })
            ]
        },
        cCats() {
            return (this.specificCats && this.specificCats.length) ? this.cCatsSpecified : this.cCatsGeneral;
        }
    },
    data: () => {
        return {
            searchTerm: '',
            catId: null,
            term: ''
        }
    },
    methods: {
        handleSearch() {
            // Implement search logic here
            console.log('Searching for:', this.term, this.catId);
            this._updateRouter();
        },
        loadFromRoute() {
            const query = this.$route.query;
            this.term = query.term || '';
            this.catId = query.catId || null;
        },
        _updateRouter() {
            // PREVENT UPDATING ROUTE FOR NOW
            let name = (this.$route.name === 'AfiliadoShowroom') ? this.$route.name : 'ProductsIndex',
                newRoute = { name, query: {} };

            console.log('Updating route query params...', newRoute);

            // if (this.term && this.term.trim() !== '') {
                newRoute.query.term = (this.term) ? _.clone(this.term) : null;
            // } else {
                // delete (newRoute.query.term);
            // }

            // if (this.catId && this.catId.toString().trim() !== '') {
                newRoute.query.catId = (this.catId) ? _.clone(this.catId) : null;
            // } else {
                // delete (newRoute.query.catId);
            // }

            // BORRA TAMBIÉN LA PÁGINA, DESDE AQUÍ SE DEBE TRABAJAR SIEMPRE CON P1
            delete newRoute.query.page;
            newRoute.query._ = _.uniqueId('hash-id-'); // Forces the refresh of the route even if the query params are the same, by adding a unique timestamp param

            console.log('Navigating to new route with updated query params...', newRoute, this.$route);

            this.$router.push(newRoute).catch(() => {
                console.log('Route navigation caused no change, continuing...');
                this.$emit('force-refresh'); // Emit an event to force refresh if the route is the same
            });
        }
    },
    beforeMount() {
        this.loadFromRoute();
    },
    watch: {
        '$route'(to, from) {
            console.log('Route changed, loading search params from route...', to, from);
            this.loadFromRoute();
        }
    },
}
</script>

<style lang="scss">
@import '@/sass/utils/_variables';

.products-search-bar {

    .limit-width {
        max-width: 1280px;
        max-width: 1366px;
    }

    .fix-cats {
        margin: 0;
        padding: 0;
        flex: 0 1 25em;
        display: block;

        @media screen and (max-width: 480px) {
            width: 80vw;
            flex: 0 1 auto;
        }

        input {
            width: 100%;
            height: calc(1.5em + 0.75rem + 2px);
            padding: 0.375rem 0.75rem;
            font-size: 1rem;
            font-weight: 400;
            line-height: 1.5;
            color: #495057;
            background-color: #fff !important;
            background-clip: padding-box;
            border: 1px solid #ced4da !important;
            border-radius: 4px !important;
            transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
            background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24'%3E%3Cpath fill='%23495057' d='M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6l-6-6l1.41-1.41z'/%3E%3C/svg%3E") !important;
            background-repeat: no-repeat;
            background-position: right 0.75rem center;
            background-size: 1.2em;
            padding-right: 2.5rem;
            cursor: pointer;
        }

    }

}
</style>